/**
 * Enum for order edit actions.
 * @readonly
 * @enum {String} OrderEditActionEnum
 */

const OrderEditActionEnum = {
  CANCEL: 'cancel',
  COPY  : 'copy',
  EDIT  : 'edit'
}

export default OrderEditActionEnum
